import { render } from "./RaceNumber.vue?vue&type=template&id=23d70864&scoped=true"
import script from "./RaceNumber.vue?vue&type=script&lang=js"
export * from "./RaceNumber.vue?vue&type=script&lang=js"

import "./RaceNumber.vue?vue&type=style&index=0&id=23d70864&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d70864"]])

export default __exports__